import { Directive } from '@angular/core';
import { ProductHostComponentBase } from '../ProductHostComponentBase';
import { ProductDetailRenderTarget, ProductDetailRenderTargetComponents } from './product-detail-layout';

@Directive()
export abstract class ProductDetailHostComponentBase extends ProductHostComponentBase {
  protected readonly LayoutTargets = ProductDetailRenderTarget;
  protected readonly LayoutComponents = ProductDetailRenderTargetComponents;
}
